import { render, staticRenderFns } from "./CustomersWiseProductSaleReport.vue?vue&type=template&id=61cfd9f4&"
import script from "./CustomersWiseProductSaleReport.vue?vue&type=script&lang=js&"
export * from "./CustomersWiseProductSaleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports